import { createSlice } from '@reduxjs/toolkit';

const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState: {
        notifications: [],
        maxNotifications: 1, // Only show one snackbar at a time
        pendingNotification: null
    },
    reducers: {
        showSnackBar: (state, action) => {
            const {
                message,
                type = 'info',
                duration = 5000,
                undoAction = null,
                undoLabel = 'Undo',
                persistent = false,
                id = null,
                uploadProgress = null
            } = action.payload;

            const notification = {
                id: id || Date.now() + Math.random(),
                message,
                type,
                duration,
                undoAction,
                undoLabel,
                persistent,
                timestamp: Date.now(),
                isExiting: false,
                uploadProgress
            };

            // If there's already a notification, mark it as exiting and store the new one as pending
            if (state.notifications.length > 0) {
                state.notifications[0].isExiting = true;
                state.pendingNotification = notification;
            } else {
                // No existing notification, show immediately
                state.notifications = [notification];
            }
        },
        showPendingNotification: (state) => {
            if (state.pendingNotification) {
                state.notifications = [state.pendingNotification];
                state.pendingNotification = null;
            }
        },
        hideSnackBar: (state, action) => {
            const id = action.payload?.id;
            if (id) {
                state.notifications = state.notifications.filter(n => n.id !== id);
            } else {
                state.notifications = [];
            }
        },
        markSnackBarExiting: (state, action) => {
            const id = action.payload.id;
            const notification = state.notifications.find(n => n.id === id);
            if (notification) {
                notification.isExiting = true;
            }
        },
        executeUndo: (state, action) => {
            const id = action.payload.id;
            state.notifications = state.notifications.filter(n => n.id !== id);
        },
        clearAllSnackBars: (state) => {
            state.notifications = [];
        },
        updateUploadProgress: (state, action) => {
            const { id, uploadProgress } = action.payload;
            const notification = state.notifications.find(n => n.id === id);
            if (notification && notification.type === 'uploading') {
                notification.uploadProgress = uploadProgress;
            }
        },
        completeUpload: (state, action) => {
            const { id } = action.payload;
            const notification = state.notifications.find(n => n.id === id);
            if (notification && notification.type === 'uploading') {
                notification.type = 'success';
                notification.message = 'File uploaded successfully!';
                notification.persistent = false;
                notification.duration = 3000;
                notification.uploadProgress = null;
            }
        }
    },
});

export const {
    showSnackBar,
    showPendingNotification,
    hideSnackBar,
    markSnackBarExiting,
    executeUndo,
    clearAllSnackBars,
    updateUploadProgress,
    completeUpload
} = snackbarSlice.actions;

export default snackbarSlice.reducer;
